import { render, staticRenderFns } from "./SolicitudDesarchivoList.vue?vue&type=template&id=5a63610f&"
import script from "./SolicitudDesarchivoList.vue?vue&type=script&lang=js&"
export * from "./SolicitudDesarchivoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports